import * as React from "react";
import { Layout } from 'antd';

import { FilterComponent } from "./FilterComponent";

const { Sider } = Layout;

export class SiderComponent extends React.PureComponent<{}> {
  render() {
    return (
      <div style={{ marginTop: 10, marginRight: 250 }}>
        <Sider width="auto" style={{ position: 'fixed', background: '#fff' }}>
          {/* <div style={{ fontSize: 15, fontWeight: 700 }}> Filters</div> */}
          {/* <div style={{ fontSize: 13, fontWeight: 600, display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 5 }}>
            <div>Manage Filters</div>
            <Icon type="filter" style={{ fontSize: 20 }} />
          </div> */}
          <div style={{ margin: 0, width: 250, marginLeft: -10 }}>
            <FilterComponent />
          </div>
        </Sider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/layout/SiderComponent.tsx